import React from 'react';
import { jsx } from '@emotion/core';
import { Button } from '../Button';
import Input from '../Input';
import * as translations from './localization';
import { useLocalization } from '../../localization';
import { addTagStyles, inputStyles, buttonStyles, closeLinkStyles } from './styles';
import { SuggestionList } from './suggestionList';
export var CreateTag = function CreateTag(_a) {
  var _b = _a.value,
      value = _b === void 0 ? '' : _b,
      _c = _a.onChange,
      onChange = _c === void 0 ? function () {} : _c,
      _d = _a.onSubmit,
      onSubmit = _d === void 0 ? function () {} : _d,
      _e = _a.suggestions,
      suggestions = _e === void 0 ? [] : _e,
      _f = _a.isValid,
      isValid = _f === void 0 ? true : _f;

  var _g = React.useState(false),
      isEditMode = _g[0],
      setEditMode = _g[1];

  var strings = useLocalization(translations).strings;
  return isEditMode ? jsx("div", {
    css: {
      position: 'relative',
      display: 'flex',
      marginTop: 8,
      marginRight: 8
    }
  }, jsx(Input, {
    autoFocus: true,
    size: "small",
    css: inputStyles,
    placeholder: strings.tagPlaceholder,
    value: value,
    onChange: onChange,
    onEnterPress: function onEnterPress() {
      return onSubmit(value);
    }
  }), jsx(Button, {
    disabled: !isValid,
    size: "small",
    css: buttonStyles,
    onClick: function onClick() {
      return onSubmit(value);
    }
  }, strings.add), jsx("button", {
    css: closeLinkStyles,
    onClick: function onClick() {
      var target = document.createElement('input');
      target.value = value;
      var nativeEvent = new Event('change', {});
      setEditMode(false);
      onChange({
        nativeEvent: nativeEvent,
        target: target,
        currentTarget: target,
        bubbles: true,
        cancelable: false,
        defaultPrevented: false,
        eventPhase: 0,
        isTrusted: true,
        preventDefault: function preventDefault() {},
        isDefaultPrevented: function isDefaultPrevented() {
          return false;
        },
        stopPropagation: function stopPropagation() {},
        isPropagationStopped: function isPropagationStopped() {
          return false;
        },
        persist: function persist() {},
        timeStamp: Date.now(),
        type: 'change'
      });
    }
  }, strings.close), jsx(SuggestionList, {
    items: suggestions,
    onClick: function onClick(suggestion) {
      return onSubmit(suggestion);
    }
  })) : jsx("button", {
    css: addTagStyles,
    onClick: function onClick() {
      return setEditMode(true);
    }
  }, strings.addTag);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/createTag.js
// module id = 1195
// module chunks = 0